import React from "react";
import { Box } from "@chakra-ui/react";

function ControllsLayout(props) {
	return (
		<Box w="100%" marginTop="auto">
			{props.children}
		</Box>
	);
}

export default ControllsLayout;
